// extracted by mini-css-extract-plugin
export default {"container":"xFWsE","innerContainer":"_1uhtE","voteIcon":"S2dcJ","voteIconInactive":"_2IWLW","voteCount":"_35bBL"};